// extracted by mini-css-extract-plugin
export default {"label":"EventGroupLabel_label--yC0","firstGroup":"EventGroupLabel_firstGroup--iAA","secondGroup":"EventGroupLabel_secondGroup--tQ1","thirdGroup":"EventGroupLabel_thirdGroup--AYd"};